import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'QuoteSalesSMSOptIn',
  props: {
  value: {
    type: Boolean,
    required: true
  }
},
  emits: ['update:value'],
  setup(__props, { emit }) {






const onChange = (value: boolean) => {
  emit('update:value', value)
}

return { __sfc: true,emit, onChange }
}

})